import { Component, OnDestroy, OnInit } from '@angular/core';
import { WidgetComponent } from '../core/widget.component';
import { ReportsService } from '../../../@apiClient/extensions';

@Component({
  selector: 'ngx-images-carousel-widget',
  styleUrls: ['./images-carousel-widget.component.scss'],
  templateUrl: './images-carousel-widget.component.html',
})
export class ImagesCarouselWidgetComponent extends WidgetComponent implements OnInit, OnDestroy {
  images: any[] = []
  constructor(reportsService: ReportsService) {
    super(reportsService);
  }
  public reloadAndRedraw() {
    this.loadData().then(() => { 
      this.images = this.data.map( x => {
        return {
          styles:{"background-image":"url('" + x.image + "')", "width": x.width},
          url: x.url
        }
      });
    });
  }
  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
